import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useAddDesignBank from "./useAddDesignBank";
import FileUpload from "../../../Global/FileUpload";
import Select from "react-select";

const AddDesignBank = ({ refetch }) => {
  const {
    formik,
    queryState,
    basicData,
    imagePreview,
    getFieldError,
    handleCloseModal,
    handleFirstImageChange,
    handleFirstImageDelete,
  } = useAddDesignBank({
    refetch,
  });

  return (
    <div className={`row`}>
      <div className="pro-mb-4 flex-fill">
        <Input
          label={"Design Id"}
          type="text"
          id="design_id"
          name="design_id"
          className={`pro-input lg ${
            formik.errors.design_id && formik.touched.design_id && " error"
          }`}
          {...formik.getFieldProps("design_id")}
          disabled={queryState?.isEdit}
        />
        {formik.errors.design_id && formik.touched.design_id && (
          <span className="error-text">{formik?.errors?.design_id}</span>
        )}
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Supplier
          </label>
          <Select
            id="supplier"
            name="supplier"
            placeholder={"Select"}
            className={`pro-input lg ${getFieldError("supplier") && " error"}`}
            classNamePrefix="pro-input"
            options={basicData?.suppliers ?? []}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?._id}
            value={formik?.values?.supplier}
            onBlur={formik.handleBlur("supplier")}
            onChange={(value) => formik?.setFieldValue("supplier", value || "")}
            menuPlacement="auto"
          />
          {getFieldError("supplier") && (
            <span className="error-text">{getFieldError("supplier")}</span>
          )}
        </div>
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Item Type
          </label>
          <Select
            id="item_type"
            name="item_type"
            placeholder={"Select"}
            className={`pro-input lg ${getFieldError("item_type") && " error"}`}
            classNamePrefix="pro-input"
            options={basicData?.items ?? []}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?._id}
            value={formik?.values?.item_type}
            onBlur={formik.handleBlur("item_type")}
            onChange={(value) => formik?.setFieldValue("item_type", value || "")}
            menuPlacement="auto"
          />
          {getFieldError("item_type") && (
            <span className="error-text">{getFieldError("item_type")}</span>
          )}
        </div>
        <FileUpload
          id={"image_url"}
          title={"Image"}
          filePreview={{
            file: imagePreview || queryState?.itemData?.image_url || "", // fallback for edit mode
          }}
          handleFileChange={handleFirstImageChange}
          handleFileRemove={handleFirstImageDelete}
          isError={formik.touched.image_url && !!formik.errors.image_url}
          errorMsg={formik.touched.image_url ? formik.errors.image_url : ""}
          maxSize="5"
          status={"success"}
        />
      </div>
      <Button className={"pro-btn-link lg pro-px-5"} onClick={handleCloseModal}>
        Cancel
      </Button>

      <Button
        className={"pro-btn-primary lg pro-ms-3"}
        type="submit"
        onClick={formik.handleSubmit}
      >
        {queryState?.isEdit ? "Update" : "Create"}
      </Button>
    </div>
  );
};

export default AddDesignBank;
